export const isValidJSON=(data:any)=>{
    try{
        JSON.parse(data);
        return true
    } catch{
        return false
    }
}